import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, ModelData, TableRowColor, QueryParameter, CommonService, NotificationService } from 'yt-ng-framework';
import { FinDokumentStavka } from '../nalog/fin-dokument-stavka';
import { UvozIzvoda } from './uvoz-izvoda';
import { List } from 'immutable';
import { IzvodStavka } from './izvod-stavka';
import { FormGroup, FormControl, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { transition } from '@angular/animations';
import { KomitentZrc } from 'src/app/lookups/komitent/komitent-zrc/komitent-zrc';
import { Komitent } from 'src/app/lookups/komitent/komitent';
import { Banka } from 'src/app/lookups/banka/banka';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-uvoz-izvoda',
  templateUrl: './uvoz-izvoda.component.html'
})
export class UvozIzvodaComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { }

  // Config={};
  // items = [];
  items : List<UvozIzvoda>;
  // items = List<UvozIzvoda>();
  gridTableColumns = [];
  modelData: ModelData;
  @Input() Parameters;
  rowColors: TableRowColor[];
  // itemFinDokumentStavka: FinDokumentStavka = <FinDokumentStavka>{};
  itemIzvodStavka: IzvodStavka;
  gridFormGroup : FormGroup = new FormGroup({
    GridControl : new FormControl('')
  });

  // gridFormGroup : FormGroup  = new FormGroup({
  //   GridControl : new FormControl('', CheckGridData())
  // });
  submitted : boolean = false;
  loading: boolean = false;

  ngOnInit() {
    
    this.items = this.Parameters[0].Value;
    this.gridTableColumns = this.Parameters[1].Value;
    // this.gridFormGroup.setValidators(CheckGridData(this.items, this.gridTableColumns));
    // this.gridFormGroup.updateValueAndValidity();
   
  }

  Close(){
    this.activeModal.dismiss();
  }

  async Save(){
      this.submitted = true;   
      // let a: boolean = this.checkGridData(this.items, this.gridTableColumns);
      if (this.checkMaxLength(this.items, this.gridTableColumns) != ""){  
        let poruka: string;
        poruka = this.checkMaxLength(this.items, this.gridTableColumns);
        this.translateService.get(['UVOZIZVODA.VALIDATION.TITLE', 'UVOZIZVODA.VALIDATION.MAXLENGTH'])
        .subscribe(translate => {
          // this.notificationService.warn(translate['UVOZIZVODA.VALIDATION.TITLE'], poruka);
          this.toastrService.warning(translate['UVOZIZVODA.VALIDATION.TITLE'], poruka);
        });
        this.loading = false;
        return;
      }

      if (this.checkGridData(this.items, this.gridTableColumns)){  
        this.loading = true;  
        for (let i = 0; i < this.items.size; i++){
          await new Promise<void>((resolve, reject) =>{
            this.itemIzvodStavka = new IzvodStavka();
            this.itemIzvodStavka.Deserialize(this.items.get(i));
            this.itemIzvodStavka.ID = -1;
            this.baseDataService.Post("IzvodStavka","post",this.itemIzvodStavka,null)
              .subscribe(()=>{
                this.submitted = false;
                resolve();
              })
            
              // provera ako nije unet žiro račun komitenta, da snimi
              let komitentID : number = this.items.get(i).KomitentID;
              let ziroRacun: string = this.items.get(i).ZiroRacunKomitenta;
              ziroRacun = ziroRacun.replace(/-/g,"");
              
              let bankaID : number;
              let zrc1 : string;
              let zrc2 : string;
              let zrc3 : string;
              zrc1 = ziroRacun.substr(0,3);
              zrc2 = ziroRacun.substr(3, ziroRacun.length-5);
              zrc2 = new CommonService().PadLeft(zrc2, "0", 13);
              zrc3 = ziroRacun.substr(ziroRacun.length - 2, 2)
              this.baseDataService.Get("banka","getIDfromUslov",[new QueryParameter('uslov', "sifra = '"+ zrc1 + "'")], Banka)
              .subscribe((result) =>{
                  if (result){
                    bankaID = Number(result);                    
                    this.baseDataService.Get("komitentzrc","getIDfromUslov",[new QueryParameter('uslov', "komitent_id = "+komitentID.toString()+" and zrc1 = '" + zrc1 + "' and zrc2 = '" + zrc2 + "' and zrc3 = '" + zrc3 + "'")], KomitentZrc)
                    .subscribe((result) =>{
                        if (!result){
                          let itemKomitentZrc = new KomitentZrc();
                          itemKomitentZrc.ID = -1;
                          itemKomitentZrc.KomitentID = komitentID;
                          itemKomitentZrc.BankaID = bankaID;
                          itemKomitentZrc.Zrc1 = zrc1;
                          itemKomitentZrc.Zrc2 = zrc2;
                          itemKomitentZrc.Zrc3 = zrc3;
                          this.baseDataService.Post("KomitentZrc", "post", itemKomitentZrc, null)
                          .subscribe();
                        }
                            
                    })
                  }
                  else{
                   // ne znam da li treba za svaki red poruka ako ne nađe banka id
                  }
                      
              })

            
              
            
          })
        }
        this.loading = false;
        this.activeModal.close(true);
      }
      else{
        this.translateService.get(['UVOZIZVODA.VALIDATION.TITLE', 'UVOZIZVODA.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['UVOZIZVODA.VALIDATION.TITLE'], translate['UVOZIZVODA.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['UVOZIZVODA.VALIDATION.TITLE'], translate['UVOZIZVODA.VALIDATION.CONTENT']);
          });
      }
      
  }

  checkGridData(items: List<UvozIzvoda>, gridTableColumns: any[]):boolean{
    if (items){
      let itemsPropertyName = Object.keys(items.get(0));
      let _required: boolean = false;
      let retVal: boolean = true;

      for (let i = 0; i < itemsPropertyName.length; i++){
        for (let j = 0; j < gridTableColumns.length; j++){
          if (itemsPropertyName[i] == gridTableColumns[j]["name"]){
            _required = gridTableColumns[j]["required"] == "true" ? true : false;
            if(_required){
              for (let k = 0; k < items.size; k++){
                retVal = true;
                switch(gridTableColumns[j]["type"]){
                  case "DDL":
                    if (items.get(k)[itemsPropertyName[i]] == null){
                      retVal = false;
                    }
                    break;
                  case "number":
                    if (items.get(k)[itemsPropertyName[i]] == 0){
                      retVal = false;
                    }
                    break;
                  case "input":
                    if (items.get(k)[itemsPropertyName[i]] == ""){
                      retVal = false;
                    }
                    break;
                }
                if (retVal == false)
                  return retVal;
              }
            }
            
          }
        }         

      }
      return retVal;
    }
    else 
      return false;
  }

  checkMaxLength(items: List<UvozIzvoda>, gridTableColumns: any[]):string{
    if (items){
      let itemsPropertyName = Object.keys(items.get(0));
      let _maxLength: number; 
      let retVal: string = "";

      for (let i = 0; i < itemsPropertyName.length; i++){
        for (let j = 0; j < gridTableColumns.length; j++){
          if (itemsPropertyName[i] == gridTableColumns[j]["name"]){
            if (gridTableColumns[j]["type"] == "input"){
              _maxLength = gridTableColumns[j]["config"]["maxLength"];
              
              if(_maxLength != undefined){
                for (let k = 0; k < items.size; k++){
                  if (items.get(k)[itemsPropertyName[i]] != undefined && items.get(k)[itemsPropertyName[i]].length > Number(_maxLength)){
                    this.translateService.get([gridTableColumns[j]["label"]])
                      .subscribe(translate => {
                        retVal = "Dužina za kolonu "+translate[gridTableColumns[j]["label"]]+" je veća od "+_maxLength;
                        return;
                      });
                  }
                }
              }
            }
          }
        }         

      }
      return retVal;
    }
    else 
      return "";
  }

}

